import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { FeathersService } from '../services/api/feathers.service';
import { filter, of, switchMap, take } from 'rxjs';

export const visitorOnlyCanMatchGuard: CanMatchFn = () => {
  const feathers = inject(FeathersService);
  const router = inject(Router);

  return feathers.initialized$.pipe(
    filter((value) => value),
    take(1),
    switchMap(() =>
      feathers.isVisitor
        ? of(true)
        : of(router.createUrlTree(['certificates', 'create']))
    )
  );
};
